import { __decorate } from "tslib";
import { Component, Prop, Vue } from "../../vue";
import DocsPanel from "../MethodEditor/components/DocsPanel";
import { DocState } from "../MethodEditor/DocState";
let DocsModalComp = class DocsModalComp extends Vue {
  render() {
    const h = arguments[0];
    const title = h("span", {
      "on": {
        "click": () => {
          DocState.getInstance().init();
        }
      }
    }, ["\u6587\u6863"]);
    return h("a-modal", {
      "attrs": {
        "title": title,
        "width": 1200,
        "height": 900,
        "visible": this.state.visible,
        "mask": false,
        "footer": null,
        "bodyStyle": {
          height: 'calc(100vh - 200px)'
        }
      },
      "on": {
        "cancel": () => this.state.hide()
      }
    }, [h(DocsPanel, {
      "attrs": {
        "contentStyle": {
          height: 'calc(100vh - 360px)'
        }
      }
    })]);
  }
};
__decorate([Prop()], DocsModalComp.prototype, "state", void 0);
DocsModalComp = __decorate([Component({
  name: 'DocsModalComp'
})], DocsModalComp);
export default DocsModalComp;
//# sourceMappingURL=DocsModalComp.js.map
